// API calls use the same origin in Docker. An explicit URL is only needed for
// unusual local workflows outside the provided Compose development stack.
const API_URL = process.env.REACT_APP_API_URL || '';

// Interface/response language helpers, read from the value the Settings page stores.
const LANGUAGE_KEY = 'uiLanguage';

const getUiLanguage = () => {
  try {
    const stored = localStorage.getItem(LANGUAGE_KEY);
    return stored === 'en' ? 'en' : 'zh-TW';
  } catch (e) {
    return 'zh-TW';
  }
};

// Azure speech-recognition locale for the current interface language.
const getSpeechLanguage = () => (getUiLanguage() === 'en' ? 'en-US' : 'zh-TW');

// Export configuration values
export {
  API_URL,
  getUiLanguage,
  getSpeechLanguage
};
